import React from 'react';
import { Box } from '../Rebass';
import { Container } from '../Container';
import styled from '@emotion/styled';
import theme from '../../theme';

interface BorderProps {
  sx?: any;
  isContainerised?: boolean;
  borderColor?: any;
}

const BorderContainer = styled(Box)``;

const StyledBorder = styled.hr`
  height: 0px;
  margin: 0px;
  padding: 0;
  border-style: solid;
  border-width: 0;
  border-bottom: 1px solid
    ${({ borderColor }: { borderColor: string }) => theme.colors[borderColor]};
`;

const Border = ({
  sx,
  borderColor = 'borderDark',
  isContainerised = true,
  ...props
}: BorderProps) => {
  let children = isContainerised ? (
    <Container>
      <StyledBorder borderColor={borderColor} />
    </Container>
  ) : (
    <StyledBorder borderColor={borderColor} />
  );

  return (
    <BorderContainer sx={sx} {...props}>
      {children}
    </BorderContainer>
  );
};

export default Border;
